<template>
  <transition name="fade" appear>
    <section class="order-info">
      <p class="order-label" :class="{ 'ready': isReady }">{{ orderLabel.toUpperCase() }}</p>
      <p class="order-number" :class="{ 'ready': isReady }">{{ ('0000' + orderNumber).slice(-4) }}</p>
    </section>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      orderLabel: 'Order'
    }
  },
  props: ['orderNumber', 'isReady'],
  computed: {
    order () {
      return this.$store.getters.getOrder
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    text-align: center;
    margin: 0;
    color: #FF6449
  }

  .order-info {
    margin: 5px;
    transition: all 0.5s ease-out;
    -webkit-transition: all 0.5s ease-out;
    height: 70px;
  }

  .order-label {
    letter-spacing: 1px;
    font-weight: 700;
    font-size: 18px;
  }

  .order-number {
    font-size: 40px;
    font-weight: 700;
  }

  .ready {
    color: #70BE00;
  }

  @media screen and (max-width: 320px) {
    .order-label {
      font-size: 16px;
    }
    .order-number {
      font-size: 25px;
      font-weight: 700;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/OrderInfo.vue